export class MonitoringFilterPlantOption {
  sapPlantId: string;
  plantCode: string;
  plantLocation: string;
  plant: string;

  constructor(params?: MonitoringFilterPlantOption) {
    if (params) {
      Object.assign(this, params);
      this.plant = Object.values(params).filter(Boolean).join(' | ');
    }
  }
}

export class MonitoringFilterGateOption {
  plantSapId: string;
  gateName: string;
  selected = false;

  get gateAndPlantSapId(): string {
    return this.gateName + this.plantSapId;
  }

  constructor(params?: MonitoringFilterGateOption) {
    if (params) {
      Object.assign(this, params);
    }
  }
}
